import React, { useContext } from 'react';
import { Icon, IconButton, Tooltip } from '@material-ui/core';
import __ from "lodash";

import { useNotes } from '../../services/notes';
import { useQueryClient } from 'react-query';
import SystemContext from '../../SystemContext';

const NotesActionButton = (props) => {

  const {
    canEdit,
    primaryObjectUuid,
    noteType,
    title,
    eventPrefix
  } = {
    canEdit: false,
    primaryObjectUuid: null,
    noteType: "",
    title: 'Note',
    eventPrefix: "NoteDialog",
    ...props
  };

  const SystemData = useContext(SystemContext);
  const eventBus = SystemData.eventBus;
  const queryClient = useQueryClient();

  const extraKeys = primaryObjectUuid?[primaryObjectUuid, noteType]:["dummy"];
  const note = useNotes({queryClient, extraKeys});

  const handleNoteClick = () => {
    eventBus.trigger(`${eventPrefix}.open`, {
      canEdit,
      primaryObjectUuid,
      noteType,
      noteUuid: note && Array.isArray(note.data) && note.data.length > 0 ? note.data[0].noteUuid:undefined,
      title,
    })
  }
  const tooltip = note && Array.isArray(note.data) && note.data.length > 0 ? note.data[0].noteText : "Add Note";
  const iconName = note && Array.isArray(note.data) && note.data.length > 0 ? "description" : canEdit ? "note_add" : "";

  const defaultStyle = {
    display: "inline-block"
  }
  const iconProps = {
    ...__.omit(props?.iconProps||{}, 'iconName', 'tooltip'),
    style: {...defaultStyle, ...props?.style, ...props?.iconProps?.style},
    disabled: props?.disabled || props?.iconProps?.disabled,
    onClick: handleNoteClick
  }
  if (iconName) {
    if (tooltip) {
      return (
        <Tooltip title={tooltip} key={`${eventPrefix}-actions`}>
          <span>
            <IconButton {...iconProps} >
              <Icon>{iconName}</Icon>
            </IconButton>
          </span>
        </Tooltip>
      )
    }
    return (
      <IconButton {...iconProps} key={`${eventPrefix}-actions`}>
        <Icon>{iconName}</Icon>
      </IconButton>
    )
  }
  return (<></>);
}
export default NotesActionButton;
